



























import { Vue, Component, Prop } from 'vue-property-decorator'
import { getKey } from '@/utils/key'

@Component
export default class Notice extends Vue {
  @Prop({
    default: () => []
  })
  notice!: (string | string[])[][]
  getKey = getKey
  isArray = (item: string | string[]) => Array.isArray(item)
}
